export default "__VITE_ASSET__DgUnRyi5__"